<div class="xgrid-debug" [attr.single-line]="singleLine() ? '' : null" [attr.standard]="standard() ? '' : null">
  @if (hasInfo()) {
    <div class="area area-important-info">
      <ideal-render-target-item-result-title *ifHasRenderInSources="LayoutComponents[LayoutTargets.Title]" />
      <ideal-render-target-item-result-important-info *ifHasRenderInSources="LayoutComponents[LayoutTargets.ImportantInfo]" />
    </div>
  }
  <div class="area area-price" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Price]">
    <ideal-render-target-item-result-price />
  </div>
  <!-- <div class="area area-info" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Info]">
    <ideal-render-target-item-result-info />
  </div> -->
  <div class="area area-stock" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Stock]">
    <ideal-render-target-item-result-stock />
  </div>
  <div class="area area-actions" *ifHasRenderInSources="LayoutComponents[LayoutTargets.Actions]">
    <ideal-render-target-item-result-actions />
  </div>
</div>

@if (typeComponentInjector() && productTypeComponents()) {
  <div style="display: none">
    @for (component of productTypeComponents(); track $index) {
      <ng-container *ngComponentOutlet="component; injector: typeComponentInjector(); inputs: componentInputs()"></ng-container>
    }
  </div>
}
